var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresaleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.813 10.875a1.688 1.688 0 110-3.375 1.688 1.688 0 010 3.375zm0-6.188L7.16 12.34a5.347 5.347 0 014.5 4.5l7.652-7.651C21 7.5 21 4.891 21 3c-1.892 0-4.5 0-6.187 1.688zM6.375 12L9.75 8.625c-2.39 0-4.5.563-6.187 3.375h2.812zM12 17.625l3.375-3.375c0 2.39-.562 4.5-3.375 6.188v-2.813zm-8.273 2.648a.561.561 0 00.796 0l4.5-4.5a.562.562 0 10-.796-.796l-4.5 4.5a.562.562 0 000 .796zm-.164-2.648a.561.561 0 01-.398-.96L6.54 13.29a.562.562 0 11.795.795L3.96 17.46a.561.561 0 01-.397.165zm2.977 3.21a.56.56 0 00.795 0l3.375-3.375a.562.562 0 10-.795-.795L6.54 20.04a.562.562 0 000 .795z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresaleFill);
export default __webpack_public_path__ + "3d4f7a5bf16057fee67a89715320ccca.svg";
export { ForwardRef as ReactComponent };